import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-action-modal',
  templateUrl: 'action-modal.component.html',
  styleUrls: ['action-modal.component.scss'],
})
export class ActionModalComponent {
  private readonly dialogRef = inject(MatDialogRef<ActionModalComponent>);
  public readonly data = inject(MAT_DIALOG_DATA) as {
    patient: Record<string, unknown>;
    actions: {
      icon: string;
      title: string;
      buttonClass: string;
      onClick: () => void;
    }[];
  };

  onActionClick(action: {
    icon: string;
    buttonClass: string;
    onClick: () => void;
  }) {
    action.onClick();
    this.dialogRef.close();
  }
}
